<template>
    <drag-modal :visible="$store.state.dislog.globalModal" @cancel="close" title='全局管理' width='500px' class="modal">
        <div class="box">
            <a-button style="width: 120px;" type="primary" icon="plus" @click='deAdd' size="large"
                v-if='$common.AccAUTH(debInfo.accuser_id, "cause:add") && debInfo.is_clear != 1'>新增</a-button>
            <a-button style="width: 120px;" icon="paper-clip" @click='seeFile(0)' size="large"
                v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:files")'>附件汇总 </a-button>
            <a-button style="width: 120px;" icon="file-protect" @click='visibleShow("CauseStepLog")' size="large"
                v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:keep:index")'>操作记录 </a-button>

        </div>
    </drag-modal>
</template>
<script>
import { mapGetters } from 'vuex'
// import { causeStepLog } from '@/server/collection'
export default {
    name: 'globalModal',
    props: {

    },
    data() {
        return {
            LaysuitInfo: {}
        }
    },
    computed: {
        ...mapGetters([
            'debInfo',
            'APIKEY',
            'caselist'
        ])

    },
    methods: {
        seeFile(type) {
            this.FileType = type
            this.visibleShow("filelist")
        },
        deAdd() {
            let casev = JSON.parse(JSON.stringify(this.caselist))
            const keys = ['accuser_id', 'team_id', 'chinaid', 'debtor_ids', 'court', 'court_id', 'bank_id']
            let info = casev.length > 0 ? casev[0] : { accused: [] }
            info.accuser_id = null
            info.id = null
            this.LaysuitInfo = info
            this.visibleShow("Laysuit")
        },
        close() {
            this.$store.dispatch('openkey', { key: 'globalModal', by: false })
        },
        visibleShow(name) {
            this.$store.dispatch("openkey", { key: name, by: true })
        },
    }
}
</script>
<style lang="less" scoped>
.box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 70px;
}
</style>